export { ApolloClient } from "./core/ApolloClient.js";
